// extracted by mini-css-extract-plugin
export var content = "contact-module--content--3596f";
export var form = "contact-module--form--cdef5";